export default {
  "content": "<path d=\"M4.26 8.147a60.436 60.436 0 00-.491 6.347A48.62 48.62 0 0112 18.904a48.62 48.62 0 018.232-4.41 60.46 60.46 0 00-.491-6.347m-15.482 0a50.59 50.59 0 00-2.658-.813A59.906 59.906 0 0112 1.493a59.903 59.903 0 0110.399 5.84c-.896.248-1.783.52-2.658.814m-15.482 0A50.712 50.712 0 0112 11.489a50.706 50.706 0 017.74-3.342M6.75 13a.75.75 0 100-1.5.75.75 0 000 1.5zm0 0V9.324A55.382 55.382 0 0112 6.444M4.993 17.992A5.981 5.981 0 006.75 13.75v-1.5\" stroke=\"#0F172A\" stroke-width=\"1.5\" stroke-linecap=\"round\" stroke-linejoin=\"round\"/>",
  "attrs": {
    "width": "24",
    "height": "20",
    "viewBox": "0 0 24 20",
    "fill": "none",
    "xmlns": "http://www.w3.org/2000/svg"
  }
};